import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getReports, selectReports } from "app/redux/salesSlice";
import { AppDispatch } from "app/redux/store";

export const useReports = (startDate?: string, endDate?: string) => {
    const dispatch = useDispatch<AppDispatch>();
    const reports = useSelector(selectReports);

    useEffect(() => {
        dispatch(getReports({ startDate, endDate }));
    }, [startDate, endDate, dispatch]);

    return reports;
};